import { Component, OnInit } from '@angular/core';
import { SessionService } from 'app/components/common/session/session.service';
import { CatalogueUserService } from 'app/components/catalogueUser/catalogue-user.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  catalogueUserData: any = {
    userName: '',
    language: ''
  };
  languages: Array<any> = [];
  eventData: object = {};
  profile: object = {
    authorities: []
  };
  roles: Array<any> = [
    {
      value: 'ROLE_ECATALOGUE_FIRA_ADMIN',
      translation: 'administrator',
      icon: 'supervisor_account',
      enabled: false
    },
    {
      value: 'ROLE_ECATALOGUE_EXHIBITOR',
      translation: 'exhibitor',
      icon: 'person',
      enabled: false
    },
    {
      value: 'ROLE_ECATALOGUE_MULTI_EXHIBITOR',
      translation: 'multiExhibitor',
      icon: 'supervisor_account',
      enabled: false
    },
    {
      value:'ROLE_ECATALOGUE_FIRA_SALES',
      translation: 'sales',
      icon: 'stand',
      enabled: false
    }
  ];

  constructor(private sessionService: SessionService, private catalogueUserService: CatalogueUserService) { }

  checkRoles() {
    for (let i = 0; i < this.profile['authorities'].length; i++) {
      for (let j = 0; j < this.roles.length;j++) {
        if (this.roles[j].value === this.profile['authorities'][i].authority) {
          this.roles[j].enabled = true;
        }
      }
    }
  }


  changeLanguage(changeLanguageIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueUserService.changeLanguage(changeLanguageIn)
      .subscribe((data: object) => {
        this.changeLanguageOk(data);
      },
        error => {
          this.changeLanguageError(error);
        });

  }

  changeLanguageOk(data) {
    this.loader.count--;
    this.catalogueUserService.setData(this.catalogueUserData);
  }

  changeLanguageError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  onLanguageChange() {

    let changeLanguageIn = {
      catalogueUserId: this.catalogueUserData.id,
      language: this.catalogueUserData.language
    }

    this.changeLanguage(changeLanguageIn);

  }



  ngOnInit() {
    this.languages = JSON.parse(this.sessionService.get('availableLanguagesLong', false));
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    this.profile = JSON.parse(this.sessionService.get('profile_' + this.eventData['sapCode'], true));
    this.catalogueUserData = this.catalogueUserService.getData();
    this.checkRoles();
  }

}
